import { FC } from "react";
import { Button, Typography } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { IconPlus } from "@tabler/icons-react";

interface EvalsHeaderProps {
  selectedCount: number;
  onRunSelected: () => void;
  onCreateTestCase: () => void;
}

export const EvalsHeader: FC<EvalsHeaderProps> = ({
  selectedCount,
  onRunSelected,
  onCreateTestCase,
}) => (
  <Stack direction="row" justify="between" align="center" className="al-mb-6">
    <Typography variant="h3">AI Evaluation</Typography>
    <Stack direction="row" gap="sm">
      <Button onClick={onRunSelected} disabled={selectedCount === 0} variant="outline" size="sm">
        Run Selected ({selectedCount})
      </Button>
      <Button onClick={onCreateTestCase} variant="outline" size="sm">
        <IconPlus className="al-w-4 al-h-4 al-mr-2" />
        Create Test Case
      </Button>
    </Stack>
  </Stack>
);
